import React, { useState, useEffect } from 'react';
import { ConfirmDialog } from '../../../confirm-dialog/confirm-dialog';

export interface IConfirmCompleteTasksDialogComponentProps {
  open: boolean;
  onConfirmClick: () => void;
  onCancelClick?: () => void;
  tasksCount: number;
}

export function ConfirmCompleteTasksDialogComponent(props: IConfirmCompleteTasksDialogComponentProps) {
  const { open, onConfirmClick, onCancelClick, tasksCount } = props;

  const [isConfirmed, setIsConfirmed] = useState(false);

  useEffect(() => {
    if (open) {
      setIsConfirmed(false);
    }
  }, [open]);

  function handleConfirmClick() {
    setIsConfirmed(true);
    onConfirmClick && onConfirmClick();
  }

  return (
    <ConfirmDialog
      title="Ønsker du at afslutte opgaverne?"
      type="question"
      open={open}
      onConfirmClick={handleConfirmClick}
      onCancelClick={onCancelClick}
      confirmButtonText="Ja, afslut opgaver"
      cancelButtonText="Afbryd"
      cancelIsPrimary={false}
      isLoading={isConfirmed}
    >
      <p>Vil du markere {tasksCount > 1 ? `de ${tasksCount} valgte poster` : 'den valgte post'} som afsluttet? Bemærk at opgaver med repetition ikke vil danne nye opgaver.</p>
      <p>
        Bemærk, at alle følgende typer poster vil blive ignoreret:
        <ul>
          <li>Poster der ikke længere er markeret som planlagt.</li>
          <li>Poster som repræsenterer tidligere migrerede planlagte samtaler</li>
        </ul>
      </p>
    </ConfirmDialog>
  );
}
